import { render, staticRenderFns } from "./OpenCartEditMain.vue?vue&type=template&id=02b0bc1d&scoped=true&"
import script from "./OpenCartEditMain.vue?vue&type=script&lang=js&"
export * from "./OpenCartEditMain.vue?vue&type=script&lang=js&"
import style0 from "./OpenCartEditMain.vue?vue&type=style&index=0&id=02b0bc1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b0bc1d",
  null
  
)

export default component.exports